import { render, staticRenderFns } from "./lesson-locked-overlay.vue?vue&type=template&id=52fb53b7&scoped=true"
import script from "./lesson-locked-overlay.vue?vue&type=script&lang=js"
export * from "./lesson-locked-overlay.vue?vue&type=script&lang=js"
import style0 from "./lesson-locked-overlay.vue?vue&type=style&index=0&id=52fb53b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb53b7",
  null
  
)

export default component.exports